import Vue from "vue";
import Component from "vue-class-component";
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate", // for vue-router 2.2+
]);
import Router from "vue-router";

const Home = () => import("@/core/home/home.vue");
const Error = () => import("@/core/error/error.vue");
const Login = () => import("@/core/login/login.vue");
// @ts-ignore
import entities from "@/router/entities.ts";

Vue.use(Router);

// prettier-ignore
export default new Router({
  mode: 'history',
  routes: [
     {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { authorities: [48] },
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Error,
      meta: { error403: true }
    },
    {
      path: '/not-found',
      name: 'NotFound',
      component: Error,
      meta: { error404: true }
    },
    ...entities
  ]
});
